// https://vuex.vuejs.org/en/actions.html
import * as types from '../constants';
import {getAxiosInstance} from "../../utils/vuex";
import {MerchantData, Outlet, Quote} from "../../entities";
import useModuleStore from '../index';
import useApplicationStore from "../application_module";
import router from "../../router/index"
import {CONVERT_PUBLIC_QUOTE} from "../constants";
export default {
    //
    async [types.FETCH_APPLICATION_PARAMETERS] (){
        const moduleStore = useModuleStore();
        const appStore=useApplicationStore();
        let is_upload_documents_page = window.location.pathname.includes('upload_documents');
        let is_documents_page = window.location.pathname.includes('documents');
        let is_review_page = window.location.pathname.includes('review');
        let is_masked_page = window.location.pathname.includes('mask');
        let can_show_page_loaded = is_upload_documents_page || is_documents_page || is_review_page || is_masked_page;
        if (can_show_page_loaded) {
            this[types.SET_LOADING_DOCUMENT_UPLOAD](true);
        }
        const url = '/application/ajaxgetparams'
        await getAxiosInstance.get(url).then(response => {
            if (response.data.result === 'SUCCESS') {
                //console.log('application data',response.data);
                this[types.SET_APPLICATION_PARAMETERS](response.data);
                this[types.SELECT_PAGE_CONFIG](response.data);
            }
            this[types.SET_LOADING_DOCUMENT_UPLOAD](false);
        })
    },

    [types.SELECT_PAGE_CONFIG] (data){
        let page_config_id = data.hasOwnProperty('page_config_id') ? data.page_config_id : '';
        let page_config = data.hasOwnProperty('PAGE_CONFIGURATION_COMBINATION')?
            data['PAGE_CONFIGURATION_COMBINATION'] : {};

        this.page_config_id = page_config_id;
        this[types.SET_PAGE_CONFIG](page_config);
    },

    [types.FETCH_APPLICATION_DATA](payload){

        const url = '/application/ajaxgetapplicationdata/' + payload.application_reference;
        let response_data = {};
        let is_upload_documents_page = window.location.pathname.includes('upload_documents');
        let is_documents_page = window.location.pathname.includes('documents');
        let is_review_page = window.location.pathname.includes('review');
        let is_masked_page = window.location.pathname.includes('mask');
        let can_show_page_loaded = is_upload_documents_page || is_documents_page || is_review_page || is_masked_page;
        if (can_show_page_loaded) {
            this[types.SET_LOADING_DOCUMENT_UPLOAD](true);
        }
        return getAxiosInstance.get(url).then(response => {
            if (response.data.result === 'SUCCESS') {
                response_data = response.data;
            }
            this[types.COMMIT_APPLICATION](response_data)
            this[types.SET_LOADING_DOCUMENT_UPLOAD](false);
        })

    },
    [types.GET_MERCHANT_VALIDATION_ERRORS](payload) {
        let url = '/application/ajaxgetvalidationerrors/' + payload.application_reference;

        if (Object.entries(this.validation_errors).length === 0) {
            getAxiosInstance.post(url, payload)
                .then(res => {
                    if (res['data']['result'] === 'SUCCESS') {
                        this.validation_errors = res['data']['validation_errors'];
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        }
    },

    [types.COMMIT_APPLICATION] (data){
        let merchant = data.hasOwnProperty('application') ? new MerchantData(data.application) : new MerchantData();
        let documents = merchant.hasOwnProperty('documents') && Array.isArray(merchant.documents) ? merchant.documents : [];
        let application_relation = data.hasOwnProperty('application_relation') ? data.application_relation : {};
        let merchant_hierarchy_configuration_templates = data.hasOwnProperty('merchant_hierarchy_configuration_templates') ? data.merchant_hierarchy_configuration_templates : {};
        let merchant_hierarchy = data.hasOwnProperty('merchant_hierarchy') ? data.merchant_hierarchy : {};
        let outlets = data.hasOwnProperty('outlets') ? data.outlets.map(obj => new Outlet(obj)) : [new Outlet()];
        let other_users = data.hasOwnProperty('users') ? data.users : {};
        let substatuses = data.hasOwnProperty('substatuses') ? data.substatuses : [];
        let can_edit = data.hasOwnProperty('can_edit') ? data.can_edit: false;
        let can_view = data.hasOwnProperty('can_view') ? data.can_view: false;
        let parameters = data.hasOwnProperty('parameters') ? data.parameters : {};
        let paypal_boarding = data.hasOwnProperty('paypal_boarding') ? data.paypal_boarding: [];

        let isApplication = location.pathname.includes('application/')
        let isQuote = location.pathname.includes('quote/')
        let isEdit = location.pathname.includes('edit/')
        let isView = location.pathname.includes('view/')
        const moduleStore = useModuleStore();
        //check user access to the Application
        let userObject = this.user;
        if ((isApplication || isQuote) && isEdit) {
            if (!can_edit) { //can't edit due to ownership and merchant control permissions
                if (!!can_view) {
                    if( !window.location.pathname.includes('document') ) {
                        if (isApplication) {
                            location.href = '/application/view/' + merchant.application_reference + '/business_details/';
                        } else if (isQuote) {
                            location.href = '/quote/view/' + merchant.quote_external_id + '/business/';
                        }
                    }
                    else {
                        moduleStore.commit(types.SET_GLOBAL_ERRORS, 'merchant_cannot_currently_edit_this_application')
                    }
                }else{
                    moduleStore.commit(types.SET_GLOBAL_ERRORS, 'merchant_does_not_have_permission_to_view_application')
                    location.href = '/'; //send them back to home because they have no relationship to the application
                }
            }
            //logic moved to ApplicationController
            // if (!!merchant.sales_owner_user_external_id) {
            //     if (merchant.sales_owner_user_external_id !== userObject.user_external_id) {
            //         if (!!merchant.merchant_owner_user_external_id) { //reason, old application won't have this field populated
            //             if (merchant.merchant_owner_user_external_id === userObject.user_external_id) {
            //                 //since they aren't sales owner they might not be able to edit.
            //                 if (merchant.hasOwnProperty('merchant_control') && merchant.merchant_control !== '1') {
            //                     store.commit(types.SET_GLOBAL_ERRORS, 'merchant_cannot_currently_edit_this_application', {root: true})
            //                     location.href ='/application/view/' + merchant.application_reference + '/business_details/';
            //                 }
            //             } else {
            //                 store.commit(types.SET_GLOBAL_ERRORS, 'merchant_does_not_have_permission_to_view_application', {root: true})
            //                 location.href = '/'; //send them back to home because they have no relationship to the application
            //             }
            //         }else{
            //             store.commit(types.SET_GLOBAL_ERRORS, 'merchant_does_not_have_permission_to_view_application', {root: true})
            //             location.href = '/'; //send them back to home because they have no relationship to the application
            //         }
            //     }
            // }
        } else if ((isApplication || isQuote) && isView) {
            if (!can_view){
                moduleStore.commit(types.SET_GLOBAL_ERRORS, 'merchant_does_not_have_permission_to_view_application')
                location.href = '/'; //send them back to home because they have no relationship to the application
            }
            // if (!!merchant.sales_owner_user_external_id) {
            //     if (merchant.sales_owner_user_external_id !== userObject.user_external_id) {
            //         if (!!merchant.merchant_owner_user_external_id) {//reason, old application won't have this field populated
            //             if (merchant.merchant_owner_user_external_id !== userObject.user_external_id) {
            //                 store.commit(types.SET_GLOBAL_ERRORS, 'merchant_does_not_have_permission_to_view_application', {root: true})
            //                 location.href = '/'; //send them back to home because they have no relationship to the application
            //             }
            //         }
            //     }
            // }
        }

        this[types.SET_MERCHANT_DATA](merchant);
        this[types.SET_DOCUMENTS_INSTANCE](documents);
        this[types.SET_MERCHANT_RELATION_DATA](application_relation);
        this[types.SET_APPLICATION_PARAMETERS]({...this.parameters, ...parameters});
        this[types.SET_OUTLETS](outlets);
        this[types.SET_MERCHANT_HIERARCHY_CONFIGURATION_TEMPLATES](merchant_hierarchy_configuration_templates);
        this[types.SET_MERCHANT_USER_DATA](other_users);
        this[types.SET_APPLICATION_SUBSTATUSES](substatuses);
        this[types.SET_MERCHANT_HIERARCHY_DATA](merchant_hierarchy);
        this[types.SET_CAN_EDIT](can_edit)
        this[types.SET_CAN_VIEW](can_view)
        this[types.SET_PAYPAL_BOARDING](paypal_boarding);

        //update portal tabs based on the application data
        this.portal_tabs.forEach((obj, index) => {
            if ((obj.is_application_tab)) {
                obj.is_active = true;
            }
        });
    },

    [types.FETCH_QUOTE_DATA](payload) {
        const url = '/quote/ajaxgetquotedata/' + payload.quote_external_id;
        let response_data = {};
        return getAxiosInstance.get(url).then(response => {
            if (response.data.result === 'SUCCESS') {
                response_data = response.data;
            }
            this[types.COMMIT_QUOTE](response_data)
        })

    },
    [types.INITIATE_QUOTE]: function (payload){
        //initiate quote
        const url = `/quote/ajaxinitiatequote`;
        const moduleStore = useModuleStore();
        this[types.TOGGLE_LOADING](true);
        moduleStore.commit('SHOW_ERROR_ALERT', '');

        return getAxiosInstance.post(url, payload).then(response => {
            if (response['data']['result'] === 'SUCCESS') {
                this[types.COMMIT_QUOTE](response.data)

                moduleStore.commit(types.TOGGLE_LOADING, false, { root: true });
                return response;
            }
            else if (response['data']['result'] === 'ERROR') {
                return response;
            }
            else {
                return false;
            }
        })
    },
    [types.UPDATE_QUOTE]: function (payload){
        //initiate quote
        const moduleStore = useModuleStore();
        const url = `/quote/ajaxupdatequote`;
        moduleStore.commit(types.TOGGLE_LOADING, true);
        moduleStore.commit('SHOW_ERROR_ALERT', '');

        return getAxiosInstance.post(url, payload).then(response => {
            if (response['data']['result'] === 'SUCCESS') {
                if (payload.section === 'BUSINESS_INFO'){
                    this[types.COMMIT_QUOTE](response.data)
                }
                else if (payload.section === 'EQUIPMENTS'){
                    const {quote} = response.data;
                    if (!!quote && !!quote.package_external_id) {
                        this.quote.package_external_id = quote.package_external_id
                    }
                }
                if (payload.section === 'PRICING'){
                    this[types.SET_QUOTE_STATUS](response.data.quote.status_external_id);

                    if (!response.data.outlets && response.data.hasOwnProperty('outlet')) {
                        response.data.outlets = [response.data.outlet];
                    }
                    if (response.data.hasOwnProperty('outlets')) {
                        this[types.COMMIT_OUTLETS](response.data);
                    }
                }
                if (!response.data.outlets && response.data.hasOwnProperty('outlet')) {
                    response.data.outlets = [response.data.outlet];
                }
                if (response.data.hasOwnProperty('outlets')) {
                    this[types.COMMIT_OUTLETS](response.data);
                }
                if (!response.data.outlets && response.data.hasOwnProperty('outlet')) {
                    response.data.outlets = [response.data.outlet];
                }
                if (response.data.hasOwnProperty('outlets')) {
                    this[types.COMMIT_OUTLETS](response.data);
                }
                if(response['data']['application_updated'] && response.data.hasOwnProperty('application')){
                    this.merchant.legal_name = response.data.application.legal_name
                }
                moduleStore.commit(types.TOGGLE_LOADING, false);
                return response;
            }
            else {
                return false;
            }
        }).catch(error => {
            throw error
            //TODO we should throw all errors and catch them in the components to use for notifyErrors
        })
    },
    [types.CONVERT_QUOTE]: function (payload){
        //initiate quote
        const moduleStore =  useModuleStore();
        const url = `/quote/ajaxconvertquote`;
        moduleStore.commit(types.TOGGLE_LOADING, true);
        moduleStore.commit('SHOW_ERROR_ALERT', '');

        return getAxiosInstance.post(url, payload).then(response => {
            if (response['data']['result'] === 'SUCCESS') {
                return response;
            }
            else {
                return false;
            }
        })
    },
    [types.CONVERT_PUBLIC_QUOTE]: function (payload){
        //initiate quote
        const moduleStore =  useModuleStore();
        const url = `/quote/ajaxconvertpublicquote`;
        moduleStore.commit(types.TOGGLE_LOADING, true);
        moduleStore.commit('SHOW_ERROR_ALERT', '');

        return getAxiosInstance.post(url, payload).then(response => {
            if (response['data']['result'] === 'SUCCESS') {
                moduleStore.commit(types.TOGGLE_LOADING, false);
                return response;
            }
            else {
                return false;
            }
        }).catch(error => {
            throw error
            //TODO we should throw all errors and catch them in the components to use for notifyErrors
        })
    },
    [types.CREATE_QUOTE_MERCHANT_USER]: function (payload){
        //create user from quote
        const moduleStore =  useModuleStore();
        const url = `/quote/ajaxcreatequotemerchantuser`;
        moduleStore.commit(types.TOGGLE_LOADING, true);
        moduleStore.commit('SHOW_ERROR_ALERT', '');

        return getAxiosInstance.post(url, payload).then(response => {
            if (response['data']['result'] === 'SUCCESS') {
                return response;
            }
            else {
                return false;
            }
        })
    },
    [types.SAVE_MERCHANT]: function (payload){
        const moduleStore =  useModuleStore();
        //save business details and principal
        const url = `/application/ajaxsavemerchant/${this.merchant.application_reference}/${payload.section}`;

        if (!!payload && payload.hasOwnProperty('banks') && Array.isArray(payload['banks'])) {
            payload.banks.forEach(bank => {
                if (bank.hasOwnProperty('bank_account_number_masked')) {
                    delete bank.bank_account_number_masked;
                }
                if (bank.hasOwnProperty('bank_sort_code_masked')) {
                    delete bank.bank_sort_code_masked;
                }
                if (bank.hasOwnProperty('iban_masked')) {
                    delete bank.iban_masked;
                }
                if (bank.hasOwnProperty('swift_masked')) {
                    delete bank.swift_masked;
                }
            });
        }

        let postData = payload;
        moduleStore.commit(types.TOGGLE_LOADING, true);
        moduleStore.commit('SHOW_ERROR_ALERT', '');

        return getAxiosInstance.post(url, postData).then(response => {
            if (response && response.data && response['data']['result'] === 'SUCCESS') {

                const {application, outlets, outlet} = response.data;
                //TODO ask wellington about this
                if(!response.data.outlets && !!response.data.outlet) response.data.outlets = [response.data.outlet]

                if (!!response.data.outlets) {
                    this[types.COMMIT_OUTLETS](response.data);
                    if (postData.section === 'PRINCIPAL') {
                        this[types.SET_MERCHANT_DATA](new MerchantData(response.data.application));
                    }

                    if(response['data']['application_updated'] && response.data.hasOwnProperty('application')){
                        this.merchant.owners = application.owners.map( owner => new Owner(owner));
                    }
                }

                moduleStore.commit(types.TOGGLE_LOADING, false);
                return response;
            }
            else {
                console.log('Error: url=', url, ', data=', response);
                return false;
            }
        })
    },
    [types.SAVE_OUTLET]: function (payload){
        //save business details and principal
        const url = `/application/ajaxupdateoutlet/${this.merchant.application_reference}/${payload.section}`;
        const moduleStore = useModuleStore();

        if (!!payload && payload.hasOwnProperty('banks') && Array.isArray(payload['banks'])) {
            payload.banks.forEach(bank => {
                if (bank.hasOwnProperty('bank_account_number_masked')) {
                    delete bank.bank_account_number_masked;
                }
                if (bank.hasOwnProperty('bank_sort_code_masked')) {
                    delete bank.bank_sort_code_masked;
                }
                if (bank.hasOwnProperty('iban_masked')) {
                    delete bank.iban_masked;
                }
                if (bank.hasOwnProperty('swift_masked')) {
                    delete bank.swift_masked;
                }
            });
        }

        moduleStore.commit(types.TOGGLE_LOADING, true);
        moduleStore.commit('SHOW_ERROR_ALERT', '');

        return getAxiosInstance.post(url, payload).then(response => {
            if (response['data']['result'] === 'SUCCESS') {
                const {application, outlets, outlet} = response.data;
                //TODO ask wellington about this
                if(!response.data.outlets && !!response.data.outlet) response.data.outlets = [response.data.outlet]

                if (!!response.data.outlets) {
                    this[types.COMMIT_OUTLETS](response.data)
                }

                moduleStore.commit(types.TOGGLE_LOADING, false);
                return response;
            }
            else {
                return false;
            }
        })
    },
    [types.SAVE_BANK_ID_PRINCIPAL_DATA](payload) {
        const moduleStore =useModuleStore();
        moduleStore.commit(types.TOGGLE_LOADING, true);
        // //console.log("Payload.data: ", payload.data);
        let url  = `/application/ajaxsavebankidprincipaldata/`;
        //let redirect_url =  `/application/edit/${payload.application_reference}/business_details/principals/`;

        moduleStore.commit(types.TOGGLE_LOADING, true);
        moduleStore.commit('SHOW_ERROR_ALERT', '');

        return getAxiosInstance.post(url, payload).then(response => {
            if (response['data']['result'] === 'SUCCESS') {
                // vm.notifySuccess(vm.lang('principal_updated_successfully'));
                //redirect to principal page, fire criipto ajax call
                // vm.redirectToPrincipalPage(vm.$route.query.state);
                //location.href = redirect_url;
                moduleStore.commit(types.TOGGLE_LOADING, false);
                return response;
            }
            else {
                return false;
            }
        });
    },
    [types.UNMASK_PII_DATA](payload) {
        const moduleStore = useModuleStore();

        moduleStore.commit(types.TOGGLE_LOADING, true);
        const url = window.location.origin +'/application/ajaxunmaskpiidata/' + this.merchant.application_reference;
        return getAxiosInstance.post(url, payload)
            .then(response => {
                moduleStore.commit(types.TOGGLE_LOADING, false);
                if (response['data']['result'] === 'SUCCESS') {
                    return response;
                }
                else {
                    return false;
                }
            })
            .finally(function () {
                moduleStore.commit(types.TOGGLE_LOADING, false);
            });
    },
///////////////////Application mutations///////////
    [types.SET_MERCHANT_DATA](payload){ this.merchant = payload },
    [types.SET_DOCUMENTS_INSTANCE](payload){ this.documents = payload },
    [types.SET_APPLICATION_STATUS](payload) {
        this.merchant['application_status_external_id'] = payload;
    },
    [types.SET_QUOTE_STATUS]: function (payload) {
        this.quote['quote_status_external_id'] = payload;
    },
    [types.SET_QUOTE_DATA](payload){ this.quote = payload },
    [types.SET_MERCHANT_RELATION_DATA](payload){ this.merchant_relation = payload },
    [types.SET_NAVIGATION](payload){ this.topTabsConfig = payload },
    [types.SET_LOGGED_IN_USER](payload){ this.user = payload },
    [types.SET_MY_LANGUAGE](payload){ this.my_language = payload },
    [types.SET_APPLICATION_PARAMETERS](payload){ this.parameters = payload },
    [types.SET_OUTLET_IN_FOCUS](payload){ this.outletInFocus = payload },
    [types.SET_APPLICATION_PAGE_TITLE](payload){ this.applicationPageTitle = payload },
    [types.SET_PAGE_CONFIG](payload){ this.page_configuration = payload },
    [types.SET_OUTLETS](payload){ this.outlets = payload },
    [types.SET_MERCHANT_USER_DATA](payload){ this.application_users = payload },
    [types.SET_MERCHANT_HIERARCHY_DATA](payload){ this.merchant_hierarchy = payload },
    [types.SET_MERCHANT_HIERARCHY_CONFIGURATION_TEMPLATES](payload){ this.merchant_hierarchy_configuration_templates = payload },
    [types.TOGGLE_LOADING](payload){ this.is_loading = payload },
    [types.SET_QUOTE_LOCK](payload){ this.quote_lock = payload }, //prevent updating quote after conversion
    [types.EQUIPMENT_OFFERING](payload){ this.equipment_offerings = payload },
    [types.ACQUIRING_OFFERING](payload){ this.acquiring_offerings = payload },
    [types.ONLINE_OFFERING](payload){ this.online_offerings = payload },
    [types.SET_APPLICATION_SUBSTATUSES](payload){ this.substatuses = payload },
    [types.SET_APPLICATION_ROOT_PATH](payload){ this.application_root_path = payload },
    [types.SET_QUOTE_ROOT_PATH](payload){ this.quote_root_path = payload },
    [types.SET_EQUIPMENT_OFFER](payload){ this.equipment_offer = payload },
    [types.SET_ACQUIRING_OFFER](payload){ this.acquiring_offer = payload },
    [types.SET_ONLINE_OFFER](payload){ this.online_offer = payload },
    [types.SET_MERCHANT_VALIDATION_ERRORS](payload){ this.validation_errors = payload },
    [types.SET_MATCHED_PACKAGES](payload){ this.matched_packages = payload },
    [types.COMMIT_QUOTE]: function (payload) {
        let quote = payload.hasOwnProperty('quote') ? new Quote(payload.quote) : {};
        let acquiring_offerings = payload.hasOwnProperty('acquiring_offerings') ? payload.acquiring_offerings : [];
        let equipment_offerings = payload.hasOwnProperty('equipment_offerings') ? payload.equipment_offerings : [];
        let online_offerings = payload.hasOwnProperty('online_offerings') ? payload.online_offerings : [];
        let matched_packages = payload.hasOwnProperty('matched_packages') ? payload.matched_packages : {}
        let criteria = payload.hasOwnProperty('criteria') ? payload.criteria : [];

        //TODO move check to the php
        //if user doesn't own the quote
        // if (!!rootState.user && quote.hasOwnProperty('user_external_id') && quote.user_external_id !== rootState.user.user_external_id){
        //     location.href = '/';
        // }


        equipment_offerings.forEach(obj => {
            obj.id = obj.equipment_offering_external_id;
            obj.text = obj.offering_name;
        })
        acquiring_offerings.forEach(obj => {
            obj.id = obj.transaction_pricing_external_id;
            obj.text = obj.offering_name;
        })
        online_offerings.forEach(obj => {
            obj.id = obj.equipment_offering_external_id;
            obj.text = obj.offering_name;
        })

        //remove offers if package is empty
        if (!quote.hasOwnProperty('package_external_id') || !quote.package_external_id){
            this.equipment_offer = {};
            this.acquiring_offer =  [];
            this.online_offer = {};
        }else if(!!quote.package_external_id){
            //if package is auto selected but no offer was saved, unset state objects
            if (Object.keys(quote.equipment_offer).length === 0) {
                this.equipment_offer = {};
            }
            if (Object.keys(quote.acquiring_offer).length === 0) {
                this.acquiring_offer = [];
            }
            if (Object.keys(quote.online_offer).length === 0) {
                this.online_offer = {};
            }
        }

        this.equipment_offerings = equipment_offerings;
        this.acquiring_offerings = acquiring_offerings;
        this.online_offerings = online_offerings;
        this.quote = {...this.quote, ...quote};
        this.matched_packages = matched_packages;
        this.criteria = criteria;
    },
    [types.COMMIT_OUTLETS] (payload) {
        let vm = this;
        let outlets = payload.hasOwnProperty('outlets') ? payload.outlets.map(obj => new Outlet(obj)) : [new Outlet()];
        outlets.forEach((outletObj) => {
            if (!!outletObj.banks && !!vm.outlets[0] && !!vm.outlets[0].banks) {
                outletObj.banks.forEach((newObj) => {
                    const itemFound = vm.outlets[0].banks.find(oldObj => oldObj.account_type == newObj.account_type);
                    if (!!itemFound.account_type && itemFound) {
                        if (!!itemFound.iban) {
                            newObj['iban'] = itemFound.iban; //no masked
                        }
                        if (!!itemFound.bank_account_number) {
                            newObj['bank_account_number'] = itemFound.bank_account_number; //no masked
                        }
                    }
                });
            }
        });
        this.outlets = outlets;
    },
    [types.SET_CAN_EDIT](payload){ this.can_edit = payload },
    [types.SET_CAN_VIEW](payload){ this.can_view = payload },
    [types.COMMIT_APPLICATION_TABS](payload){ this.application_tabs = payload },
    [types.SET_GO_BACK_WARNING_MODAL](payload){ this.disable_go_back_warning_modal = payload },
    [types.SET_PAYPAL_BOARDING](payload){ this.paypal_boarding = payload },
    [types.SET_LOADING_DOCUMENT_UPLOAD](payload){ this.loading_document_upload = payload },
}